<template>
  <box-generic
    v-if="title && content?.length"
    :header="title"
    class="material-box"
  >
    <template v-for="(contentItem, index) in content" :key="index">
      <div v-if="contentItem._rendered" v-html="contentItem._rendered" />
    </template>
  </box-generic>
</template>

<script>
import BoxGeneric from "../BoxGeneric.vue";

export default {
  name: "MaterialBox",
  components: {
    BoxGeneric,
  },
  props: {
    title: {
      type: String,
    },
    content: {
      type: Array,
    },
  },
};
</script>
